import { render, staticRenderFns } from "./employer-custom-questions.vue?vue&type=template&id=98dd9722"
import script from "./employer-custom-questions.vue?vue&type=script&lang=js"
export * from "./employer-custom-questions.vue?vue&type=script&lang=js"
import style0 from "./employer-custom-questions.vue?vue&type=style&index=0&id=98dd9722&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports